var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay active"},[_c('div',{staticClass:"background",on:{"click":_vm.closePopup}}),_c('div',{staticClass:"dialog"},[_c('h3',[_vm._v("Choose your options")]),_c('ProductListVue')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }